import { BuildModuleParamsType } from 'types/api-internal';
import {
  SugarMoneyApiCoinsRequestType,
  SugarMoneyApiCoinsResponseType,
  SugarMoneyApiSearchCoinsRequestType,
  SugarMoneyApiSearchCoinsResponseType,
} from 'types/coins';

export const coinsModule = ({ makeApiRequest }: BuildModuleParamsType) => ({
  get: async ({
    page = 0,
    filter,
    bondingCurveFrom,
    bondingCurveTo,
    marketCapFrom,
    marketCapTo,
    coinAgeFrom,
    coinAgeTo,
    solPriceUsd,
    toShow,
    doNotShow,
    coinHoldersFrom,
    coinHoldersTo,
    hideNsfw,
  }: SugarMoneyApiCoinsRequestType) => {
    return makeApiRequest<SugarMoneyApiCoinsResponseType>({
      endpoint: `coins`,
      options: { method: 'get' },
      searchParams: {
        page,
        filter,
        bondingCurveFrom,
        bondingCurveTo,
        marketCapFrom,
        marketCapTo,
        coinAgeFrom,
        coinAgeTo,
        solPriceUsd,
        toShow,
        doNotShow,
        coinHoldersFrom,
        coinHoldersTo,
        hideNsfw,
      },
    });
  },

  search: async ({ searchTerm, page = 0, hideNsfw }: SugarMoneyApiSearchCoinsRequestType) =>
    makeApiRequest<SugarMoneyApiSearchCoinsResponseType>({
      endpoint: `coins/search`,
      options: { method: 'get' },
      searchParams: { searchTerm, page, hideNsfw },
    }),
});
